var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleCloudLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "38px",
    viewBox: "0 0 48 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "google-cloud-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "playground",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-large",
    transform: "translate(-616.000000, -406.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-cloud-logo",
    transform: "translate(616.000000, 406.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9231718,10.4895833 L36.0930396,6.38125 L36.3700441,4.65208333 C28.772511,-2.15625 16.6942731,-1.38333333 9.84317181,6.2625 C7.94008811,8.38541667 6.52969163,11.0333333 5.7769163,13.76875 L7.26977974,13.5604167 L15.6095154,12.20625 L16.2523348,11.5583333 C19.9612335,7.54375 26.2350661,7.00416667 30.5170044,10.41875 L31.9231718,10.4895833 Z",
    id: "Path",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0348899,13.6458333 C41.0770044,10.16875 39.10837,7.04166667 36.3721586,4.65 L30.5191189,10.4166667 C32.9910132,12.40625 34.3971806,15.4020833 34.3379736,18.5458333 L34.3379736,19.56875 C37.2137445,19.56875 39.5460793,21.8666667 39.5460793,24.7 C39.5460793,27.5333333 37.2137445,29.775 34.3379736,29.775 L23.9069604,29.775 L22.8835242,30.8708333 L22.8835242,37.0270833 L23.9069604,37.99375 L34.3379736,37.99375 C41.819207,38.0520833 47.9323348,32.1791667 47.9915419,24.8083333 C48.027489,20.3395833 45.7903084,16.15 42.0348899,13.6458333",
    id: "Path",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4886344,37.99375 L23.9069604,37.99375 L23.9069604,29.7770833 L13.4886344,29.7770833 C12.7506608,29.7770833 12.0232599,29.61875 11.3529515,29.3166667 L9.87488987,29.7625 L5.6754185,33.8708333 L5.30960352,35.26875 C7.66519824,37.0208333 10.5388546,38.00625 13.4886344,37.99375",
    id: "Path",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4886344,11.3395833 C6.00528634,11.3833333 -0.0232599119,17.3958333 0.0211453744,24.76875 C0.0465198238,28.8854167 1.99823789,32.7604167 5.30960352,35.2708333 L11.3529515,29.3166667 C8.73092511,28.15 7.56581498,25.1104167 8.74995595,22.5270833 C9.93409692,19.94375 13.019207,18.7958333 15.6412335,19.9625 C16.7957709,20.4770833 17.7219383,21.3875 18.2442291,22.5270833 L24.2875771,16.5729167 C21.7162996,13.2604167 17.7198238,11.325 13.4886344,11.3395833",
    id: "Path",
    fill: "#FBBC05"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloudLogo);
export default __webpack_public_path__ + "static/media/google-cloud-logo.6e539064444609926b2c63ecff94a87d.svg";
export { ForwardRef as ReactComponent };